import React from "react";
import { InputRangeRow } from "./index";
// Used by Leesona 861 FC, Tackified, and Wax Winders and the Sahm 230E machine

export default function GearFRow({ minProp, maxProp, errorProp }) {
   return (
      <InputRangeRow
         titleProp={"Gear F"}
         descriptionProp={""}
         sizeProp={4}
         colSizeProp={3}
         typeProp={"text"}
         minProp={minProp}
         maxProp={maxProp}
         propertyNameProp={"gearF"}
         errorDialogueProp={errorProp || "Cannot be empty"}
         floatProp={false}
      />
   );
}
